import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-become-gatho-venue',
  templateUrl: './become-gatho-venue.component.html',
  styleUrls: ['./become-gatho-venue.component.scss']
})
export class BecomeGathoVenueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
